import URL from '../url'
import Request from '../request'

/**
 *
 */
export const LLMHealthCheckService = () =>
  new Request(URL.APP_URL_LLM, URL.HEALTH).get()

/**
 *
 * @param {*} chatData
 * @param {*} applicationId
 */
export const LLMSendChatMessageService = chatData =>
  new Request(URL.API, URL.SEND_CHAT_MESSAGE).post(chatData)

/**
 *
 * @param {*} applicationId
 */
export const LLMGetChatsService = () =>
  new Request(
    URL.APP_URL_LLM,
    URL.GET_CHATS.replace('{applicationId}', URL.APP_LLM_KEY),
  ).get()

/**
 *
 * @param {*} chatId
 */
export const LLMGetChatMessagesService = chatId => {
  return new Request(
    URL.APP_URL_LLM,
    URL.GET_CHAT_MESSAGES.replace('{applicationId}', URL.APP_LLM_KEY).replace(
      '{chatId}',
      chatId,
    ),
  ).get()
}

/**
 *
 * @param {*} formData
 */
export const LLMUploadAttachmentService = formData =>
  new Request(
    URL.APP_URL_LLM,
    URL.UPLOAD_CHAT_ATTACHMENT.replace('{applicationId}', URL.APP_LLM_KEY),
  ).post(formData)

/**
 *
 * @param {*} chatId
 * @param {*} attachmentId
 */
export const LLMDeleteAttachmentService = (chatId, attachmentId) =>
  new Request(
    URL.APP_URL_LLM,
    URL.DELETE_CHAT_ATTACHMENT.replace('{applicationId}', URL.APP_LLM_KEY)
      .replace('{chatId}', chatId)
      .replace('{attachmentId}', attachmentId),
  ).delete()

/**
 *
 * @param {*} chatId
 * @param {*} outline
 */

export const LLMUpdateChatMessageService = (chatId, outline) => {
  return new Request(
    URL.APP_URL_LLM,
    URL.UPDATE_CHAT_MESSAGE.replace('{applicationId}', URL.APP_LLM_KEY).replace(
      '{chatId}',
      chatId,
    ),
  ).put(outline)
}

/**
 * @param {*} chatId
 * @param {*} attachmentId
 *
 */

export const LLMCheckAttachmentStatusService = (chatId, attachmentId) => {
  return new Request(
    URL.APP_URL_LLM,
    URL.CHECK_ATTACHMENT_STATUS.replace('{applicationId}', URL.APP_LLM_KEY)
      .replace('{chatId}', chatId)
      .replace('{attachmentId}', attachmentId),
  ).get()
}

/**
 *
 * @param {*} courseId
 * @param {*} languageCode
 * @param {*} chatId
 */
export const LLMFinalToolService = (
  courseId,
  languageCode,
  chatId,
  isMobile,
  courseCode,
) => {
  return new Request(
    URL.APP_URL_LLM,
    URL.FINAL_TOOL.replace('{applicationId}', URL.APP_LLM_KEY)
      .replace('{courseId}', courseId)
      .replace('{languageCode}', languageCode)
      .replace('{chatId}', chatId)
      .replace('{isMobile}', isMobile)
      .replace('{courseCode}', courseCode),
  ).get()
}

/**
 *
 * @param {*} content
 * @param {*} languageCode
 * @param {*} courseType
 */

export const LLMGetTranslatedContentService = (
  content,
  languageCode,
  courseType,
) => {
  return new Request(URL.APP_URL_LLM, URL.GET_TRANSLATED_CONTENT).post({
    content,
    languageCode,
    courseType,
  })
}
